// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getSupplierRequest: ['data'],
  getSupplierSuccess: ['data'],
  getSupplierFailure: ['err'],

  createSupplierRequest: ['data'],
  createSupplierSuccess: ['data'],
  createSupplierFailure: ['err'],

  updateSupplierRequest: ['data'],
  updateSupplierSuccess: ['data'],
  updateSupplierFailure: ['err'],

  deleteSupplierRequest: ['data'],
  deleteSupplierSuccess: ['data'],
  deleteSupplierFailure: ['err']

})

export const SupplierTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_SUPPLIER_SUCCESS]: success,
  [Types.GET_SUPPLIER_REQUEST]: request,
  [Types.GET_SUPPLIER_FAILURE]: failure,

  [Types.CREATE_SUPPLIER_SUCCESS]: success,
  [Types.CREATE_SUPPLIER_REQUEST]: request,
  [Types.CREATE_SUPPLIER_FAILURE]: failure,

  [Types.UPDATE_SUPPLIER_SUCCESS]: manipulateSuccess,
  [Types.UPDATE_SUPPLIER_REQUEST]: manipulateRequest,
  [Types.UPDATE_SUPPLIER_FAILURE]: manipulateFailure,

  [Types.DELETE_SUPPLIER_SUCCESS]: manipulateSuccess,
  [Types.DELETE_SUPPLIER_REQUEST]: manipulateRequest,
  [Types.DELETE_SUPPLIER_FAILURE]: manipulateFailure

})



// WEBPACK FOOTER //
// ./src/Redux/SupplierRedux.js